import { Spinner, Text } from '@cubeyou-team/hx-react-components';
import { AI_GRADIENT_PROPERTIES } from '@discover-frontend/constants';
import React, { FC } from 'react';

import translations from 'src/lang';
import { useStanleyQueryHistoryList } from '../../../../api/hooks';

import { StanleyQueryHistoryHeader } from './components/stanley-query-history-header';
import { StanleyQueryHistoryItem } from './components/stanley-query-history-item';
import { StanleyQueryPanelErrorState } from '../stanley-query-panel-error-state';

const { STANLEY_QUERY: translation } = translations['en-US'];
const tH = translation.MODAL.HISTORY;

export const StanleyQueryHistory: FC = () => {
  const {
    data: listData,
    isLoading: isListLoading,
    isFetching: isListFetching,
    isError: isListError,
    refetch,
  } = useStanleyQueryHistoryList();

  const isHistoryLoading = isListLoading || isListFetching;
  const showHistoryError = isListError && !isHistoryLoading;

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-auto">
      <StanleyQueryHistoryHeader />
      {isHistoryLoading && (
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2">
          <Spinner gradient={AI_GRADIENT_PROPERTIES} />
        </div>
      )}
      {showHistoryError && (
        <StanleyQueryPanelErrorState onTryAgain={() => refetch()} />
      )}
      {!isHistoryLoading && !showHistoryError && listData?.length === 0 && (
        <Text variant="dark_lighter">{tH.EMPTY}</Text>
      )}
      {!isHistoryLoading && !showHistoryError && listData && listData.length > 0 && (
        <StanleyQueryHistoryItem data={listData} />
      )}
    </div>
  );
};
